import { useEffect, } from 'react';
import {
    Box,
    Paper,
} from '@mui/material';
import { useSubscriptionContext } from '../../../context/subscription/SubscriptionContext';
import { useNavigate } from "react-router-dom";
import ConfirmOrders from "./ConfirmOrders";
import ConfirmationForm from './ConfirmationForm';
import { useOrdersContext } from '../../../context/subscription/orders/OrdersContext';
import DiscountForm from './DiscountForm';
import OrdersTable from './OrdersTable';
import Grid2 from '@mui/material/Unstable_Grid2';

const Orders = () => {
    const { selectedPlan } = useSubscriptionContext();
    const { handleGetReceiptId } = useOrdersContext()

    const navigate = useNavigate();

    // it is for initial render without discount code
    // if there is no plan (pages refreshes) it goes to subscription page
    useEffect(() => {
        handleGetReceiptId();
        if (!selectedPlan) navigate("/subscription")
    }, [])

    // pay
    // const payBill = async () => {
    //     setIsLoading((prev) => ({...prev, payBill: true}))
    //
    //     const data = await sendData({}, `/payment/zarinpal/${receiptId}`)
    //     if (data?.data?.status === true &&  data?.data?.redirectUrl) {
    //         window.location.href = data?.data?.redirectUrl;
    //     }
    //     setIsLoading((prev) => ({...prev, payBill: false}))
    // }


    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, p: { xs: 2, md: 4, xl: 8 } }}>
            <OrdersTable />
            <Paper sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: { xs: "column", md: "row", gap: 8 } }}>
                <DiscountForm />
                <ConfirmationForm />
            </Paper>
            <ConfirmOrders />
        </Box>
    );
};

export default Orders;
